import { Shot } from '@/features/shotlist/store/useShotListStore'
import { shotListRepository } from '@/features/shotlist/repository/ShotListRepository'
import { db } from '@/shared/lib/db'

export const getShotListFromDB = async (projectId: string, sceneId: string): Promise<Shot[] | null> => {
    try {
        const result = await db.shotlists
            .where('[projectId+sceneId]')
            .equals([projectId, sceneId])
            .first()
        console.log('Fetched shot list from DB', { projectId, sceneId, },result)
        return result ? result.shots : null
    } catch (error) {
        console.error('Error fetching shot list from DB:', error)
        return null
    }
}

export const saveShotListToDB = async (projectId: string, sceneId: string, shots: Shot[]) => {
    try {
        await shotListRepository.saveShots(projectId, sceneId, shots)
    } catch (error) {
        console.error('Error saving shot list to DB:', error)
        throw error
    }
}
